export const DEFAULT_DATA_TEST_ATTRIBUTES = {
  'root': 'collapse-panel__root',
  'header-wrapper': 'collapse-panel__header-wrapper',
  'header': 'collapse-panel__header',
  'collapse-icon': 'collapse-panel__collapse-icon',
  'content': 'collapse-panel__content',
};
